import { useAppContext } from "app/AppContext";
import RodadaForm from "entity/Rodada/components/RodadaForm";
import PainelControle from "entity/Rodada/components/PainelControle";
import RodadaConsulta from "entity/Rodada/components/RodadaConsulta";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import DashboardReuniaoNow from "entity/Rodada/components/DashboardReuniaoNow";
import EtiquetaAvulsa from "entity/Rodada/components/EtiquetaAvulsa"
import { useIsAdmin, useIsEmpresa } from 'useAuth'
import DashboardReunioesRealtime from "entity/Rodada/components/DashboardReunioesRealtime";



export default function RoutesMenusRodada() {
    const navigate = useNavigate();
    const { addMenu, addRoute, removeMenusRoutes } = useAppContext();
    const isAdminOuEmpresa = useIsAdmin() || useIsEmpresa



    useEffect(() => {

        if (isAdminOuEmpresa) {
            addRoute({ uid: "rodada", title: "Rodada", route: "rodada", element: <RodadaForm /> })

            addMenu({
                uid: "consultaRodada",
                text: "Rodadas",
                sequence: "000002",
                iconName: "ScatterPlot", //ou Workspaces
                parent: {
                    uid: "CadastrosP",
                    text: "Cadastros",
                    iconName: "PlaylistAdd",
                },
                action: () => {
                    navigate("/consulta-rodada")
                },
            })

            addRoute({ uid: "consultaRodada", title: "Rodadas", route: "consulta-rodada", element: <RodadaConsulta /> })
        }

        addRoute({
            uid: "painelControle",
            title: "Painel de Controle",
            route: "painel-controle",
            element: <PainelControle />
        });

        addRoute({
            uid: "dashboardNow",
            title: "dashboardNow",
            route: "dashboard",
            element: <DashboardReuniaoNow />
        });
        addRoute({
            uid: "realtime",
            title: "realtime",
            route: "realtime",
            element: <DashboardReunioesRealtime />
        });

        addRoute({
            uid: "etiquetaAvulsa",
            title: "etiquetaAvulsa",
            route: "etiquetaAvulsa",
            element: <EtiquetaAvulsa />
        })
        // addMenu({
        //     uid: "painelControle",
        //     text: "Painel de Controle",
        //     sequence: "222220",
        //     iconName: "Dvr", 
        //     action: () => {
        //         navigate("/painel-controle");
        //     },
        // });


        return () => {
            removeMenusRoutes(["rodada", "consultaRodada", "painelControle", "dashboardNow"]);
        };
    }, [addMenu, addRoute, isAdminOuEmpresa, navigate, removeMenusRoutes]);

    return null;
}